export const timeSince = (date) => {
  let seconds = Math.floor((new Date() - date) / 1000);

  let interval = seconds / 31536000;

  if (interval > 1) {
    return Math.floor(interval) + " years";
  }

  interval = seconds / 2592000;
  if (interval > 1) {
    return Math.floor(interval) + " months";
  }

  interval = seconds / 86400;
  if (interval > 1) {
    return Math.floor(interval) + " days";
  }

  interval = seconds / 3600;
  if (interval > 1) {
    return Math.floor(interval) + " hours";
  }

  interval = seconds / 60;
  if (interval > 1) {
    return Math.floor(interval) + " minutes";
  }

  if (Math.floor(seconds) > 0) {
    return Math.floor(seconds) + " seconds";
  }

  return "Just now";
};

export async function setItemLocalStorate(key, value) {
  await null;
  localStorage.setItem(key, value);
}

export async function getItemLocalStorate(key) {
  await null;
  return localStorage.getItem(key);
}

export function formatDate(date) {
  if (!(date instanceof Date)) {
    date = new Date(date);
  }

  if (isNaN(date)) {
    throw new Error("Invalid date");
  }

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is zero-indexed
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function convertTZ(date, tzString) {
  return new Date((typeof date === "string" ? new Date(date) : date).toLocaleString("en-US", { timeZone: tzString }));
}

export const getUSToday = () => {
  const usDate = new Date().toLocaleDateString("en-US", {
    timeZone: "America/Los_Angeles", // Adjust for US timezone (e.g., Eastern Time)
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });

  // Convert the date to "YYYY-MM-DD" format
  const [month, day, year] = usDate.split("/");
  return `${year}-${month}-${day}`;
};